import { render, staticRenderFns } from "./HistoricalQuotationAgro.vue?vue&type=template&id=f9c4ada8"
import script from "./HistoricalQuotationAgro.vue?vue&type=script&lang=js"
export * from "./HistoricalQuotationAgro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports